import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinokhladelhi() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Okhla Delhi',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Okhla Delhi',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Okhla Delhi, catering to the transportation needs of corporate offices, business parks, and industrial units in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Okhla Delhi.',

    top: 'Top Places to Visit in Delhi with Pune Corporate Car',

"topPlaces": [
  {
    "title": "India Gate",
    "description": "India Gate is a towering war memorial located at the heart of New Delhi, built to honor soldiers of the British Indian Army who died in World War I. Surrounded by wide lawns and beautiful avenues, it is a popular spot for picnics, evening walks, and photography. The Amar Jawan Jyoti, an eternal flame, adds a solemn and reflective atmosphere. Street vendors selling snacks, flowers, and souvenirs create a lively environment, especially during evenings and weekends."
  },
  {
    "title": "Red Fort",
    "description": "The Red Fort is a UNESCO World Heritage Site and a symbol of Mughal architecture in Delhi. Built in 1639 by Emperor Shah Jahan, the fort’s massive red sandstone walls, intricate carvings, and grand gates showcase the grandeur of the Mughal era. Visitors can explore Diwan-i-Aam, Diwan-i-Khas, and museums inside, while the fort hosts the annual Independence Day flag-hoisting ceremony, attracting thousands of spectators."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar is the tallest brick minaret in the world, standing at 73 meters, and a UNESCO World Heritage Site. Built in 1193, it features intricate Indo-Islamic architecture with inscriptions and carvings. The surrounding Qutub complex includes ancient tombs, mosques, and lush gardens, offering history enthusiasts a serene space for exploration, photography, and educational trips."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb is a magnificent Mughal mausoleum built in 1570, renowned for its Persian-style architecture and beautifully landscaped gardens. It is considered a precursor to the Taj Mahal and is a UNESCO World Heritage Site. The tomb’s symmetrical design, water channels, and tranquil environment make it an ideal spot for history lovers, photographers, and visitors seeking a peaceful retreat in Delhi."
  },
  {
    "title": "Lotus Temple",
    "description": "The Lotus Temple, also called the Bahá’í House of Worship, is famous for its lotus-shaped architecture and serene surroundings. Open to people of all faiths, it provides a peaceful environment for meditation, reflection, and spiritual exploration. The temple’s gardens, water pools, and quiet ambiance enhance the visitor experience, making it a unique spiritual and architectural landmark."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a modern cultural and spiritual complex showcasing traditional Indian architecture, art, and heritage. The sprawling site includes intricately carved stone temples, exhibitions on Indian history, musical fountains, and lush gardens. Visitors can explore the temple, attend cultural shows, and enjoy the evening light and sound display, offering both educational and spiritual experiences."
  },
  {
    "title": "Connaught Place",
    "description": "Connaught Place is New Delhi’s commercial and social hub, featuring colonial-era architecture, circular plazas, and bustling streets with shops, restaurants, and cafés. It is ideal for shopping, dining, nightlife, and people-watching. The central park hosts events and festivals, making it a lively and vibrant area that combines history, commerce, and leisure."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, one of India’s largest mosques, was built in 1656 by Emperor Shah Jahan. The mosque features grand red sandstone and marble architecture, spacious courtyards, and tall minarets. Visitors can climb the minarets for panoramic views of Old Delhi, explore the bustling surrounding bazaars, and experience the rich cultural and spiritual atmosphere of the area."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is the memorial dedicated to Mahatma Gandhi, marked by a simple black marble platform amidst serene gardens. It is a place of reflection, visited by people from across India and the world. The peaceful surroundings, eternal flame, and commemorative plaques make it a revered site for learning about Gandhi’s life and philosophy."
  },
  {
    "title": "Lodhi Gardens",
    "description": "Lodhi Gardens is a historic park blending natural beauty with architectural heritage. It features tombs from the Lodhi dynasty, landscaped gardens, walking and jogging paths, and tree-lined avenues. The park is a favorite spot for morning walkers, families, photographers, and tourists seeking a calm, scenic, and recreational environment in the midst of Delhi’s urban landscape."
  }
],


"services": [
{
"name": "Okhla Industrial Cab",
"description": "Okhla Industrial Cab provides dependable and well-managed transportation services for employees, supervisors, factory teams, and shift workers across Okhla Industrial Area Phase 1, 2, and 3. Equipped with GPS-enabled vehicles, experienced chauffeurs, optimized industrial routes, and multi-shift support, this service ensures smooth, safe, and timely daily mobility for manufacturing units, warehouses, and production facilities operating in Okhla."
},
{
"name": "Employee Shuttle Okhla",
"description": "Employee Shuttle Okhla offers large-scale, efficiently scheduled shuttle services designed to transport employees to and from Okhla’s industrial and commercial zones. Featuring minibuses, vans, and multi-passenger vehicles with trained drivers and advanced tracking, the service ensures punctual, comfortable, and reliable transportation for corporate offices, factories, and logistics teams working in the region."
},
{
"name": "Company Cab Okhla Delhi",
"description": "Company Cab Okhla Delhi delivers dedicated corporate cab services tailored for organizations requiring consistent staff mobility. With professional chauffeurs, well-maintained sedans and SUVs, GPS tracking, and streamlined scheduling, the service supports daily office commute, cross-city meetings, and management-level transportation for companies operating in Okhla and nearby business clusters."
},
{
"name": "Factory Worker Pickup Drop Okhla",
"description": "Factory Worker Pickup Drop Okhla specializes in reliable transport solutions for industrial staff, production teams, and shift-based workers. The service includes multi-capacity vehicles, trained drivers familiar with industrial-area routes, punctual pickup-drop operations, and strict safety standards—ensuring seamless workforce commuting for factories, warehouses, and manufacturing units in Okhla."
},
{
"name": "Business Taxi Okhla",
"description": "Business Taxi Okhla offers flexible and premium taxi services for corporate executives, office staff, and business travelers. With clean vehicles, highly trained chauffeurs, route optimization, and on-time pickup guarantees, the service supports meetings, client visits, inter-office travel, and business mobility across Delhi NCR."
},
{
"name": "Affordable Corporate Cabs Okhla",
"description": "Affordable Corporate Cabs Okhla provides cost-effective yet highly reliable transportation solutions for companies seeking safe and efficient employee commute. With comfortable sedans and SUVs, professional drivers, GPS monitoring, and structured operational planning, it ensures economical yet high-quality mobility for organizations of all sizes."
},
{
"name": "Monthly Cab Okhla",
"description": "Monthly Cab Okhla offers long-term, fixed-plan transportation services for companies requiring consistent daily employee commuting. With dedicated vehicles, trained chauffeurs, predictable monthly pricing, automated scheduling, and real-time trip tracking, the service ensures uninterrupted and efficient staff mobility throughout the month."
},
{
"name": "Best Corporate Cab Okhla",
"description": "Best Corporate Cab Okhla delivers premium, high-standard mobility solutions for corporate offices, executives, and employees. Featuring well-maintained luxury sedans, executive SUVs, trained chauffeurs, route planning, and punctual operations, it ensures safe, reliable, and top-quality transportation tailored for corporate needs."
},
{
"name": "Outstation Cab Okhla",
"description": "Outstation Cab Okhla offers comfortable and safe intercity travel for business trips, factory visits, site inspections, and corporate tours. The service includes long-distance-ready sedans and SUVs, trained highway drivers, flexible scheduling, GPS tracking, and round-the-clock availability for smooth outstation corporate travel."
},
{
"name": "Sedan Cab Okhla",
"description": "Sedan Cab Okhla provides premium sedan vehicles ideal for office commute, executive transfers, client transportation, and corporate mobility. With clean interiors, professional chauffeurs, GPS monitoring, and reliable operations, the service ensures a polished and comfortable travel experience for employees and managers."
},
{
"name": "SUV Cab Okhla",
"description": "SUV Cab Okhla offers spacious and highly comfortable SUVs suitable for team travel, industrial site visits, group commutes, and long-distance corporate mobility. With skilled drivers, GPS tracking, powerful vehicles, and flexible scheduling, it ensures safe and efficient transportation for all business needs."
},
{
"name": "Corporate Fleet Okhla",
"description": "Corporate Fleet Okhla provides end-to-end fleet management solutions for companies needing consistent daily employee transport. The service covers dedicated sedans, SUVs, vans, and shuttles along with driver deployment, maintenance, GPS tracking, optimized routing, and shift-based operations for smooth and well-organized corporate mobility."
},
{
"name": "Staff Mobility Okhla",
"description": "Staff Mobility Okhla offers complete employee transport solutions designed to support daily commute, multi-shift operations, and corporate workforce movement. With trained chauffeurs, GPS-enabled vehicles, route planning, safety monitoring, and real-time coordination, it ensures uninterrupted staff mobility for companies in the Okhla industrial region."
},
{
"name": "Office Commute Okhla",
"description": "Office Commute Okhla ensures reliable and punctual daily transportation for office staff working in corporate, manufacturing, and service sectors in Okhla. The service includes well-planned pickup-drop routes, trained drivers, comfortable vehicles, and real-time monitoring to ensure a smooth, comfortable, and timely office commute."
},
{
"name": "Industrial Shuttle Okhla Delhi",
"description": "Industrial Shuttle Okhla Delhi offers large-scale worker transportation solutions with multi-passenger vans, minibuses, and industrial-route-optimized vehicles. The service supports factories, warehouses, production plants, and logistics hubs by delivering safe, timely, and highly coordinated employee transport for all operational shifts."
}
],

"tableData": [
["Okhla Industrial Cab", "Employee Shuttle Okhla"],
["Company Cab Okhla Delhi", "Factory Worker Pickup Drop Okhla"],
["Business Taxi Okhla", "Affordable Corporate Cabs Okhla"],
["Monthly Cab Okhla", "Best Corporate Cab Okhla"],
["Outstation Cab Okhla", "Sedan Cab Okhla"],
["SUV Cab Okhla", "Corporate Fleet Okhla"],
["Staff Mobility Okhla", "Office Commute Okhla"],
["Industrial Shuttle Okhla Delhi", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Okhla Delhi",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Okhla Delhi, ensuring smooth, safe, and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Okhla’s industrial areas, business hubs, and office zones, enabling employees to reach their destinations without delays."
  },
  {
    "WhyChooseheading": "Professional & Skilled Drivers",
    "WhyChoosedescription": "Our trained chauffeurs follow high corporate travel standards, providing safe, courteous, and comfortable rides for employees and executives in Okhla."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all regularly sanitized, serviced, and maintained for a smooth and comfortable corporate commute."
  },
  {
    "WhyChooseheading": "Tailored Corporate Cab Packages",
    "WhyChoosedescription": "We offer customized cab rental plans designed to meet the specific transportation needs of companies and employees in Okhla Delhi."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Assistance",
    "WhyChoosedescription": "Our support team is available 24/7 for bookings, emergencies, and route adjustments, ensuring uninterrupted travel services for businesses."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized frequently and equipped with advanced safety features, ensuring secure and hygienic commuting for employees and corporate guests."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "We simplify corporate travel through seamless booking processes and efficient coordination, making employee transportation completely hassle-free."
  }
]






























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Okhla, Delhi?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and employees in Okhla Industrial Area, Delhi.',
  },
  {
    question: 'What types of corporate cab services are available in Okhla?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet management solutions.',
  },
  {
    question: 'Do you support daily commuting for employees in Okhla?',
    answer: 'Yes, we offer optimized daily commute solutions with timely pickups, route planning, and shift-based transportation for Okhla companies.',
  },
  {
    question: 'How can companies book corporate cab services in Okhla Delhi?',
    answer: 'Bookings can be made through our website, mobile app, or through our 24×7 corporate travel support team.',
  },
  {
    question: 'What types of vehicles are offered for corporate cab services?',
    answer: 'We provide hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on corporate requirements and employee count.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Okhla?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing.',
  },
  {
    question: 'Are your cabs equipped with GPS and safety features?',
    answer: 'Yes, all vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs.',
  },
  {
    question: 'Do you provide multi-shift employee transportation in Okhla?',
    answer: 'Yes, we manage transportation for multiple shifts, including night shifts, early morning shifts, and rotational schedules.',
  },
  {
    question: 'What payment modes are accepted for corporate cab services in Okhla?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and offer corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Varun Chhabra',
    feedback: 'Reliable and efficient corporate cab service in Okhla. The pickups are always on time and the drivers are professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Gulati',
    feedback: 'Great service for employee transportation in Okhla. Clean vehicles and seamless coordination every day.',
    rating: 5,
  },
];


































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Okhla Delhi",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-okhla-delhi.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides professional corporate cab services in Okhla Delhi, including industrial employee transport, factory worker pickup & drop, staff shuttles, company cabs, business taxis, monthly cab plans, outstation trips, and chauffeur-driven executive vehicles for companies operating in Okhla and surrounding industrial areas.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-okhla-delhi"
  }
};






  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in Okhla Delhi | Employee & Industrial Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Okhla Delhi including industrial employee transport, factory worker pickup & drop, staff shuttles, company cabs, business taxis, monthly cab plans, outstation trips, and chauffeur-driven executive vehicles for companies in Okhla."
  />

  <meta
    name="keywords"
    content="Okhla Industrial Cab, Employee Shuttle Okhla, Company Cab Okhla Delhi, Factory Worker Pickup Drop Okhla, Business Taxi Okhla, Affordable Corporate Cabs Okhla, Monthly Cab Okhla, Best Corporate Cab Okhla, Outstation Cab Okhla, Sedan Cab Okhla, SUV Cab Okhla, Corporate Fleet Okhla, Staff Mobility Okhla, Office Commute Okhla, Industrial Shuttle Okhla Delhi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinokhladelhi;